<template>
    <div class="polyester">
        <img
            src="@/assets/img/reaktionen/polykondensation.gif"
            alt="Polykondensation"
            title="Polykondensation"
            width="100%"
        />
        <small
            ><a
                href="https://www.lernhelfer.de/schuelerlexikon/chemie-abitur/artikel/polykondensation"
                target="_blank"
                >Quelle</a
            ></small
        >
    </div>
</template>

<script>
export default {
    name: 'polyester',
};
</script>
